import { FC, useState } from 'react';
import { useZakeke } from 'zakeke-configurator-react';

import Modal from '../Modal';
import ItemText from './ItemText';

interface EditTextItem {
  guid: string;
  name: string;
  text: string;
  fillColor: string;
  fontFamily: string;
  fontWeight: string;
  fontSize: number;
  isTextOnPath: boolean;
  constraints: { [key: string]: any } | null;
}

const AddTextDialog: FC<{ onClose: () => void; onConfirm: (item: EditTextItem) => void; isVisible: boolean }> = ({
  onClose,
  onConfirm,
  isVisible,
}) => {
  const { fonts, getPrintingMethodsRestrictions } = useZakeke();
  const textRestrictions = getPrintingMethodsRestrictions();

  const [item, setItem] = useState<EditTextItem>({
    guid: '',
    name: '',
    text: 'Text',
    fillColor: textRestrictions.defaultColor,
    fontFamily: fonts[0].name,
    fontSize: 48,
    fontWeight: 'normal normal',
    isTextOnPath: false,
    constraints: null,
  });

  const handleItemPropChange: any = (item: any, prop: any, value: any) => {
    let weightData: string[] = [];

    let newItem = { ...item } as EditTextItem;

    switch (prop) {
      case 'text':
        newItem.text = value as string;
        break;
      case 'font-italic':
        weightData = newItem.fontWeight.split(' ');
        let isBold = weightData.length > 1 ? weightData[1] === 'bold' : weightData[0] === 'bold';
        newItem.fontWeight = (value ? 'italic' : 'normal') + ' ' + (isBold ? 'bold' : 'normal');
        break;
      case 'font-bold':
        weightData = newItem.fontWeight.split(' ');
        let isItalic = weightData.length > 1 ? weightData[0] === 'italic' : false;
        newItem.fontWeight = (isItalic ? 'italic' : 'normal') + ' ' + (value ? 'bold' : 'normal');
        break;
      case 'font-color':
        newItem.fillColor = value as string;
        break;
      case 'font-family':
        newItem.fontFamily = value as string;
        break;
      case 'text-path':
        newItem.isTextOnPath = value as boolean;
        break;
    }

    setItem(newItem);
  };

  return (
    <Modal title={'Add text'} buttons={[{ label: 'Confirm', onClick: () => onConfirm(item) }]} close={onClose} isVisible={isVisible} btnClose={'x'}>
      <ItemText item={item} handleItemPropChange={handleItemPropChange} hideRemoveButton={true} />
    </Modal>
  );
};

export default AddTextDialog;
